// import React, { useState } from "react";
// import Select from "react-select";
// import { Checkbox, FormControlLabel } from "@mui/material";
// import api from "../../api/api";
// import { useParams } from "react-router-dom";
// import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";

// const EditPopup = ({ isOpen,dt, editalert, onClose,fetchsuggestions,selectedEdit, getordersData,data }) => {
//   const [selectedOption, setSelectedOption] = useState({
//     value: "all",  // Default to "All"
//     label: "All"
//   });
//   const [checked, setChecked] = useState({});
//   const [loading, setLoading] = useState(false); // Loading state

//   const practiseid = window.getPracticeId();

//   const handleChange = (selectedOption) => {
//     setSelectedOption(selectedOption);
//     setChecked({});
//   };

//   const handleCheckboxChange = (event, name) => {
//     setChecked((prev) => ({
//       ...prev,
//       [name]: event.target.checked,
//     }));
//   };


//   const handleSelectAllChange = () => {
//     const isCurrentlySelected = checked.all || false;

// const allKeys = [
//   ...getordersData.look.map((item) => item.ordre_id),
//   ...getordersData.notes.map((item) => item.ordre_id || item.id),
//   ...getordersData.rx_recipe.map((item) => item.ordre_id || item.orderid),
//   ...getordersData.referrals.map((item) => item.ordre_id || item.id),
// ];

//     const updated = {};
//     allKeys.forEach((key) => {
//       updated[key] = !isCurrentlySelected;
//     });

//     updated.all = !isCurrentlySelected;

//     setChecked(updated);
//   };

//   const filteredData = () => {
//     // Check the selected option from dropdown
//     const selectedContext = selectedOption?.value; // e.g. 'Schedule', 'Mrecord', 'Injection', etc.
  
//     // If selectedOption is 'all', show all data
//     if (selectedContext === "all") {
//       return [
//         ...getordersData.look,
//         ...getordersData.notes,
//         ...getordersData.rx_recipe,
//         ...getordersData.referrals,
//       ];
//     }
  
//     // Filter the look data based on the selected context
//     const filteredLookData = getordersData.look.filter(item => item.context === selectedContext);
  
//     // Return filtered look data based on the selected context
//     if (selectedContext === "labs") {
//       return getordersData.look.filter(item => item.context === "Labs");
//     } else if (selectedContext === "Mrecord") {
//       return getordersData.look.filter(item => item.context === "Mrecord");
//     } else if (selectedContext === "Schedule") {
//       return getordersData.look.filter(item => item.context === "Schedule");
//     } else if (selectedContext === "Injection") {
//       return getordersData.look.filter(item => item.context === "Injection");
//     } else if (selectedContext === "Procedure") {
//       return getordersData.look.filter(item => item.context === "Procedure");
//     } else if (selectedContext === "Referrals") {
//       return getordersData.referrals;
//     }else if (selectedContext.toLowerCase() === "vitamin") {
//   return getordersData.look.filter(
//     item => item.context?.toLowerCase() === "vitamin"
//   );

//     }else if (selectedContext === "Notes") {
//       return getordersData.notes;
//     }else {
//       return filteredLookData; // Default filter for the selected context
//     }
//   };
  
  
//   // const filteredData = () => {
//   //   // Remove the conditional checks and just return all items
//   //   return [
//   //     ...getordersData.look,
//   //     ...getordersData.notes,
//   //     ...getordersData.rx_recipe,
//   //     ...getordersData.referrals
//   //   ];
//   // };
  

//   const handleClearAll = () => {
//     setChecked({});
//   };

//   const handleDelete = async () => {
//     const selectedIds = [];

//     getordersData.look.forEach((item) => {
//       if (checked[item.ordre_id]) {
//         selectedIds.push(item.ordre_id);
//       }
//     });

//     getordersData.notes.forEach((item) => {
//       if (checked[item.ordre_id]) {
//         selectedIds.push(item.id);
//       }
//     });
//     getordersData.rx_recipe.forEach((item) => {
//       if (checked[item.ordre_id]) {
//         selectedIds.push(item.orderid);
//       }
//     });
//     getordersData.referrals.forEach((item) => {
//       if (checked[item.ordre_id]) {
//         selectedIds.push(item.id);
//       }
//     })
//     if (selectedIds.length === 0) {
//       editalert("No items selected", "error");
//       return;
//     }

//     setLoading(true); // Set loading state
//     try {
//       const response = await api.delete(`/v1/${practiseid}/orders/delete/multiple`, {
//         data: {
//           ordersArray: selectedIds,
//           orderdate:
//             dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
//               ? dt.split(" ")[0]
//               : new Date().toISOString().split("T")[0],
//         },
//       });
//       if (response.status === 200) {
//         editalert("Item Deleted Successfully");
        
//         fetchsuggestions()
//         onClose(); // Close the popup after successful deletion
//         handleClearAll()
//       } else {
//         editalert("Something went Wrong", "error");
//       }
//     } catch (error) {
//       editalert("Error while deleting items", "error");
//     } finally {
//       setLoading(false); // Reset loading state
//     }

//   };

//   const isDeleteDisabled = loading || !Object.values(checked).some((val) => val);
//   // Calculate the number of selected checkboxes excluding 'checked.all'
// const selectedCount = Object.entries(checked)
//   .filter(([key, value]) => key !== 'all' && value).length;



// const updateScheduleStatus = async (idToUse, schStatus) => {
  
//   const aptdate = new Date(data.startdate);
//   const formattedDate = aptdate.toLocaleDateString('en-CA'); // 'en-CA' gives the format YYYY-MM-DD

  
//   try {
//     const response = await api.put(`/v1/${practiseid}/orders/sch-status/update`, {
//       orderid: idToUse,  // Pass the orderid or id
//       sch_status: schStatus,  // Pass the schStatus ('T' or 'F')
//        order_date: formattedDate
//     });

//     if (response.status === 200) {
//       onClose();  // Close the popup after successful update
//       fetchsuggestions()
//     } else {
//       editalert("Schedule Updated");  // Inform the user of success
//     }
//   } catch (error) {
//     editalert("Error while updating schedule", "error");  // Error alert
//   } finally {
//     setLoading(false);  // Hide loading state
//   }
// };
  
// const handleButtonClick = (schStatus, ordreId) => {
//   // Use ordreId if it exists, else fallback to orderid or id
//   const idToUse = ordreId ;
  
//   // Call updateScheduleStatus with the appropriate idToUse and schStatus
//   updateScheduleStatus(idToUse, schStatus);
// };
  

//   return (
//     isOpen && (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//         <div className="relative flex flex-col gap-2 w-[80%] md:w-[480px] lg:w-[480px] bg-white px-4 pb-4 rounded-lg shadow-lg text-left">
//           <div className="w-full flex items-center justify-end">
//             <button
//               className="text-gray-500 hover:text-gray-700 text-[30px]"
//               onClick={onClose}
//             >
//               &times;
//             </button>
//           </div>

//           <div className="mt-2">
//           <Select
//   value={selectedOption}
//   onChange={handleChange}
//   options={[
//     { value: "all", label: "All" },
//     { value: "Labs", label: "Labs" },
//     { value: "Procedure", label: "Procedure" },
//     { value: "Injection", label: "Injection" },
//     { value: "Schedule", label: "Schedule" },
//     { value: "Mrecord", label: "Mrecord" },
//     { value: "Notes", label: "Notes" },
//     { value: "Referrals", label: "Referrals" },
//   ]}
//   placeholder="Select Option"
//   className="react-select-container"
//   classNamePrefix="react-select"
// />

//           </div>

//           <div className='flex justify-between w-full'>
//             <button
//               onClick={handleSelectAllChange}
//               className={`rounded-full py-2 px-4 transition text-sm duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
//                 checked.all
//                   ? "bg-[#E17954] text-white"
//                   : "bg-[#F3F3F3] text-[#686868]"
//               }`}
//             >
//               Select All
//             </button>

//             <div>
//             <button
//               onClick={handleClearAll}
//               className="rounded-full py-2 px-4 transition text-sm duration-300 ease-in-out  text-[#686868]"
//             >
//               Clear Selection
//             </button>
//           </div>
//           </div>

//           <div className="overflow-y-auto p-0 custom-scrollbar max-h-[400px] border-gray-300 pt-2">
//             {filteredData().map((item) => (
//               <div
//                className={`w-full flex justify-between items-center mb-1 px-2 
//       ${
//         item.status === "CANCELLEDTASK" || item.status === "COMPLETED"
//           ? "opacity-50"
//           : ""
//       }`}
//                 key={item.ordername}
//               >

// <div className="flex flex-row items-center gap-2 ">
// <div className="mb-2">
//   {/* STATUS ICON */}
//     {String(item.status).toUpperCase() === "COMPLETED" && COMPLETEDIcon}
//     {String(item.status).toUpperCase() === "CANCELLEDTASK" && CROSSIcon}

// </div>
    


//        <FormControlLabel
//   key={item.ordre_id}
//   control={
//     <Checkbox
//       checked={checked[item.ordre_id] || false}
//       onChange={(e) => handleCheckboxChange(e, item.ordre_id)}
//       color="primary"
//     />
//   }
//   label={
//     item.ordername.length > 18
//       ? item.ordername.slice(0, 14) + "..."
//       : item.ordername
//   }
// />
// </div>
                
           

//                   <div>
//                   {/* {item.schedule} */}
//                   {(getordersData.referrals.some(referral => referral.ordername === item.ordername) || 
//   getordersData.rx_recipe.some(recipe => recipe.ordername === item.ordername) || 
//   getordersData.notes.some(note => note.ordername === item.ordername)) ? (
//         <button
//         onClick={() => handleButtonClick('f', item.ordre_id)} 
//           className={`px-3 py-1 border-[1.5px] border-[#ccc] text-[white] rounded-full mr-1 text-[14px] bg-[#E17954]`}
//         >
//           Today
      
//         </button>
//       ) : (
//         <>
//           <button
//             onClick={() => handleButtonClick('f', item.ordre_id)} 
//             className={`px-3 py-1 border-[1.5px] border-[#ccc] text-[black] rounded-full mr-1 text-[14px] ${
//               item.schedule === 'f' ? 'bg-[#E17954] text-white' : ''
//             }`}
//           >
//             Today
            
//           </button>
//           <button
//             onClick={() => handleButtonClick('t', item.ordre_id)}
//             className={`px-3 py-1 border-[1.5px] border-[#ccc] text-[black] rounded-full mr-1 text-[14px] ${
//               item.schedule === 't' ? 'bg-[#E17954] text-white' : ''
//             }`}
//           >
//             Schedule
//           </button>
//         </>
//       )}

//                   </div> 
//               </div>
//             ))}
//           </div>

//           <div className="w-full flex justify-center mt-2">
//             <button
//               onClick={handleDelete}
//               className={`rounded w-full bg-[black] py-2 px-4 transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
//                 isDeleteDisabled ? "bg-[#18181B] text-white cursor-not-allowed" : "bg-[#50869A] text-[#FFFFFF]"
//               }`}
//               disabled={isDeleteDisabled}
//             >
//               {loading ? "Deleting..." : `Delete  Selected (${selectedCount})`}
//             </button>
//           </div>
//         </div>
//       </div>
//     )
//   );
// };

// export default EditPopup;



import React, { useState } from "react";
import Select from "react-select";
import { Checkbox, FormControlLabel } from "@mui/material";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";

const EditPopup = ({
  isOpen,
  dt,
  editalert,
  onClose,
  fetchsuggestions,
  selectedEdit,
  getordersData,
  data,
}) => {
  const [selectedOption, setSelectedOption] = useState({
    value: "all", // Default to "All"
    label: "All",
  });
  const [checked, setChecked] = useState({});
  const [loading, setLoading] = useState(false); // Loading state

  const practiseid = window.getPracticeId();

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setChecked({});
  };

  const handleCheckboxChange = (event, name) => {
    setChecked((prev) => ({
      ...prev,
      [name]: event.target.checked,
    }));
  };

  const handleSelectAllChange = () => {
    const isCurrentlySelected = checked.all || false;
    console.log("Select All Clicked. Current 'all' status:", isCurrentlySelected);

    const allKeys = [
      ...getordersData.look.map((item) => item.ordre_id),
      ...getordersData.notes.map((item) => item.ordre_id || item.id),
      ...getordersData.rx_recipe.map((item) => item.ordre_id || item.orderid),
      ...getordersData.referrals.map((item) => item.ordre_id || item.id),
    ];
    console.log("All Keys for Select All:", allKeys);

    const updated = {};
    allKeys.forEach((key) => {
      updated[key] = !isCurrentlySelected;
    });

    updated.all = !isCurrentlySelected;

    setChecked(updated);
  };

  const filteredData = () => {
    const selectedContext = selectedOption?.value;

    if (selectedContext === "all") {
      return [
        ...getordersData.look,
        ...getordersData.notes,
        ...getordersData.rx_recipe,
        ...getordersData.referrals,
      ];
    }

    const filteredLookData = getordersData.look.filter(
      (item) => item.context === selectedContext
    );

    if (selectedContext === "labs") {
      return getordersData.look.filter((item) => item.context === "Labs");
    } else if (selectedContext === "Mrecord") {
      return getordersData.look.filter((item) => item.context === "Mrecord");
    } else if (selectedContext === "Schedule") {
      return getordersData.look.filter((item) => item.context === "Schedule");
    } else if (selectedContext === "Injection") {
      return getordersData.look.filter((item) => item.context === "Injection");
    } else if (selectedContext === "Procedure") {
      return getordersData.look.filter((item) => item.context === "Procedure");
    } else if (selectedContext === "Referrals") {
      return getordersData.referrals;
    } else if (selectedContext.toLowerCase() === "vitamin") {
      return getordersData.look.filter(
        (item) => item.context?.toLowerCase() === "vitamin"
      );
    } else if (selectedContext === "Notes") {
      return getordersData.notes;
    } else {
      return filteredLookData; // Default filter for the selected context
    }
  };

  const handleClearAll = () => {
    setChecked({});
  };

  const handleDelete = async () => {
    const selectedIds = [];

    getordersData.look.forEach((item) => {
      if (checked[item.ordre_id]) {
        selectedIds.push(item.ordre_id);
      }
    });

    getordersData.notes.forEach((item) => {
      if (checked[item.ordre_id || item.id]) {
        selectedIds.push(item.ordre_id || item.id);
      }
    });
    getordersData.rx_recipe.forEach((item) => {
      if (checked[item.ordre_id]) {
        selectedIds.push(item.orderid);
      }
    });
    getordersData.referrals.forEach((item) => {
      if (checked[item.ordre_id]) {
        selectedIds.push(item.id);
      }
    });

    if (selectedIds.length === 0) {
      editalert("No items selected", "error");
      return;
    }

    setLoading(true); // Set loading state
    try {
      const response = await api.delete(`/v1/${practiseid}/orders/delete/multiple`, {
        data: {
          ordersArray: selectedIds,
          orderdate:
            dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
              ? dt.split(" ")[0]
              : new Date().toISOString().split("T")[0],
        },
      });

      if (response.status === 200) {
        editalert("Item Deleted Successfully");

        fetchsuggestions();
        onClose(); // Close the popup after successful deletion
        handleClearAll();
      } else {
        editalert("Something went Wrong", "error");
      }
    } catch (error) {
      editalert("Error while deleting items", "error");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const isDeleteDisabled = loading || !Object.values(checked).some((val) => val);

  const selectedCount = Object.entries(checked)
    .filter(([key, value]) => key !== "all" && value).length;

  const updateScheduleStatus = async (idToUse, schStatus) => {
    const aptdate = new Date(data.startdate);
    const formattedDate = aptdate.toLocaleDateString("en-CA"); // 'en-CA' gives the format YYYY-MM-DD

    try {
      const response = await api.put(`/v1/${practiseid}/orders/sch-status/update`, {
        orderid: idToUse,
        sch_status: schStatus, // Pass the schStatus ('T' or 'F')
        order_date: formattedDate,
      });

      if (response.status === 200) {
        onClose(); // Close the popup after successful update
        fetchsuggestions();
      } else {
        editalert("Schedule Updated"); // Inform the user of success
      }
    } catch (error) {
      editalert("Error while updating schedule", "error"); // Error alert
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  const handleButtonClick = (schStatus, ordreId) => {
    // Use ordreId if it exists, else fallback to orderid or id
    const idToUse = ordreId;

    // Call updateScheduleStatus with the appropriate idToUse and schStatus
    updateScheduleStatus(idToUse, schStatus);
  };

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="relative flex flex-col gap-2 w-[80%] md:w-[480px] lg:w-[480px] bg-white px-4 pb-4 rounded-lg shadow-lg text-left">
          <div className="w-full flex items-center justify-end">
            <button
              className="text-gray-500 hover:text-gray-700 text-[30px]"
              onClick={onClose}
            >
              &times;
            </button>
          </div>

          <div className="mt-2">
            <Select
              value={selectedOption}
              onChange={handleChange}
              options={[
                { value: "all", label: "All" },
                { value: "Labs", label: "Labs" },
                { value: "Procedure", label: "Procedure" },
                { value: "Injection", label: "Injection" },
                { value: "Schedule", label: "Schedule" },
                { value: "Mrecord", label: "Mrecord" },
                { value: "Notes", label: "Notes" },
                { value: "Referrals", label: "Referrals" },
              ]}
              placeholder="Select Option"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </div>

          <div className="flex justify-between w-full">
            <button
              onClick={handleSelectAllChange}
              className={`rounded-full py-2 px-4 transition text-sm duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                checked.all
                  ? "bg-[#E17954] text-white"
                  : "bg-[#F3F3F3] text-[#686868]"
              }`}
            >
              Select All
            </button>

            <div>
              <button
                onClick={handleClearAll}
                className="rounded-full py-2 px-4 transition text-sm duration-300 ease-in-out text-[#686868]"
              >
                Clear Selection
              </button>
            </div>
          </div>

          <div className="overflow-y-auto p-0 custom-scrollbar max-h-[400px] border-gray-300 pt-2">
            {filteredData().map((item) => (
              <div
                className={`w-full flex justify-between items-center mb-1 px-2 ${
                  item.status === "CANCELLEDTASK" || item.status === "COMPLETED"
                    ? "opacity-50"
                    : ""
                }`}
                key={item.ordername}
              >
                <div className="flex flex-row items-center gap-2 ">
                  <div className="mb-2">
                    {String(item.status).toUpperCase() === "COMPLETED" &&
                      COMPLETEDIcon}
                    {String(item.status).toUpperCase() === "CANCELLEDTASK" &&
                      CROSSIcon}
                  </div>

                  <FormControlLabel
                    key={item.ordre_id || item.id}
                    control={
                      <Checkbox
                        checked={checked[item.ordre_id || item.id] || false}
                        onChange={(e) =>
                          handleCheckboxChange(e, item.ordre_id || item.id)
                        }
                        color="primary"
                      />
                    }
                    label={
                      item.ordername.length > 18
                        ? item.ordername.slice(0, 14) + "..."
                        : item.ordername
                    }
                  />
                </div>

                <div>
                  {(getordersData.referrals.some(
                    (referral) => referral.ordername === item.ordername
                  ) ||
                    getordersData.rx_recipe.some(
                      (recipe) => recipe.ordername === item.ordername
                    ) ||
                    getordersData.notes.some(
                      (note) => note.ordername === item.ordername
                    )) ? (
                    <button
                      onClick={() => handleButtonClick("f", item.ordre_id)}
                      className="px-3 py-1 border-[1.5px] border-[#ccc] text-[white] rounded-full mr-1 text-[14px] bg-[#E17954]"
                    >
                      Today
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => handleButtonClick("f", item.ordre_id)}
                        className="px-3 py-1 border-[1.5px] border-[#ccc] text-[black] rounded-full mr-1 text-[14px] bg-[#E17954]"
                      >
                        Today
                      </button>
                      <button
                        onClick={() => handleButtonClick("t", item.ordre_id)}
                        className="px-3 py-1 border-[1.5px] border-[#ccc] text-[black] rounded-full mr-1 text-[14px]"
                      >
                        Schedule
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="w-full flex justify-center mt-2">
            <button
              onClick={handleDelete}
              className={`rounded w-full bg-[black] py-2 px-4 transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                isDeleteDisabled
                  ? "bg-[#18181B] text-white cursor-not-allowed"
                  : "bg-[#50869A] text-[#FFFFFF]"
              }`}
              disabled={isDeleteDisabled}
            >
              {loading ? "Deleting..." : `Delete Selected (${selectedCount})`}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default EditPopup;